export const landingUrl = process.env.REACT_APP_LANDING_URL || 'http://localhost:3001';

export function localizedLandingUrl(language?: string) {
    const normalized = language?.toLowerCase().split('-')[0];
    const locale = normalized && ['pl', 'en', 'ru', 'uk'].includes(normalized) ? normalized : 'pl';
    return new URL(`/${locale}`, landingUrl).href;
}
